<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-loyalty-index">

    <page-title :title="'Program lojalnościowy'" :back="true"></page-title>

    <card-loyalty-about></card-loyalty-about>

    <loyalty-segment :value="'LoyaltyIndex'"></loyalty-segment>

    <div v-for="(item,index) in rules" :key="index">
      <item-loyalty-rule
          :index="index+1"
          :title="item.title"
          :image="item.image">
      </item-loyalty-rule>
    </div>

    <h4 class="text-center mt-10">Masz pytania? Skontaktuj się z nami!</h4>
    <ion-list lines="none">
      <div v-for="(item,index) in navigation" :key="item.route">
        <!--show only item with tel-->
        <!--hopefully this is correct-->
        <ion-item v-if="item.route.includes('tel:')"
                  mode="ios"
                  class="ion-activatable"
                  :disabled="item.disabled">
          <ion-label mode="md" class="ion-text-wrap">
            <a :href="item.route">
              <h3>{{ item.title }}</h3>
              <p v-if="item.content">{{ item.content }}</p>
            </a>
          </ion-label>
        </ion-item>
      </div>
    </ion-list>

  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import ItemLoyaltyRule from '@/items/ItemLoyaltyRule.vue';
  import CardLoyaltyAbout from '@/cards/CardLoyaltyAbout';
  import LoyaltySegment from '@/navs/LoyaltySegment';

  export default {
    name: 'LoyaltyIndex',
    components: { PageTitle, CardLoyaltyAbout, LoyaltySegment, ItemLoyaltyRule },
    computed: {
      ...mapState({
        loading: state => state.loyalty.loading,
        rules: state => state.loyalty.rules,
        navigation: state => state.config.navigation ? state.config.navigation.contact : [],
      }),
    },
    mounted() {
      this.$store.dispatch('loyalty/LOYALTY_BRANDS_REQUEST')
      this.$store.dispatch('loyalty/LOYALTY_RULES_REQUEST')
    }
  }
</script>

<style lang="scss" scoped>
  ion-item,
  ion-list{
    --background: #f2f2f2;
  }
  ion-list{
    margin-bottom: 5px;
    padding: 0;
  }
</style>